import { Content, Item, Root, Trigger } from '@radix-ui/react-accordion';
import { type FC } from 'react';

import Icon from 'molecules/Icon';

import { setConnectorsFilter, useConnectorsFilter } from 'layout/Listing/variants/connectors/store';

import { hasArrayValues } from 'utils/array/arrays';

interface FilterProps {
  label?: string;
  items: string[];
}

const Filters: FC<FilterProps> = ({ label, items }) => {
  const activeFilter = useConnectorsFilter();

  return (
    <Root type="single" defaultValue="toc" collapsible className="flex w-full flex-col gap-4">
      <Item value="toc">
        <Trigger className="group flex w-full flex-row items-center justify-between gap-4 border-b border-b-gray-400 pb-4 text-gray-900 dark:text-white">
          <span className="text-left font-spaceGrotesk text-xl font-bold lg:block">{label || 'In this article'}</span>
          <Icon
            icon="chevron-down"
            size={24}
            className="stroke-2 transition-transform group-data-[state=open]:rotate-180"
          />
        </Trigger>
        <Content className="w-full overflow-hidden data-[state=closed]:animate-accordionSlideUp data-[state=open]:animate-accordionSlideDown">
          <ul className="flex w-full flex-col gap-2 pt-4">
            {hasArrayValues(items) &&
              items.map(item => (
                <li key={item}>
                  <button
                    className="flex w-full rounded-lg p-3 text-left text-md font-semibold text-gray-900 transition-colors hover:bg-primary-700 hover:text-white focus:border focus:border-solid focus:border-primary-700 data-[active=true]:bg-primary-800 data-[active=true]:text-white data-[active=true]:shadow-tocTabBoxShadow dark:text-gray-300"
                    onClick={() => setConnectorsFilter(item)}
                    data-active={activeFilter === item}
                    aria-label={`Filter by ${item}`}
                  >
                    {item}
                  </button>
                </li>
              ))}
          </ul>
        </Content>
      </Item>
    </Root>
  );
};

export default Filters;
